const id_mitra = {
    "": "mitra SCM online",
    btn_request: "permintaan kemitraan",
    connect_to: "terhubung dengan",

    label: {
        connect_text: "telah terhubung dengan",
        no_tag: 'tidak ada tag',
    },

    menu: {
        confirmation: "konfirmasi permintaan mitra",
        product: "daftar produk mitra",
        product_own: "daftar produk yang dibagikan",
        search: "cari mitra",
    },

}

export default id_mitra;